export default function NationalNightOut() {
    return (
        <div className="accordion-item">
        <h2 className="accordion-header">
          <button className="accordion-button caret-off collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseNationalNightOut">
            <div className="custom-button-layout">
            <img className="day-icon" src="../img/cal-icons/august-4-icon.png" alt="August 4 Calendar Icon" />
            <b>National Night Out</b>
            <span className="badge text-bg-danger">FREE EVENT</span>
            </div>
          </button>
        </h2>
        <div id="collapseNationalNightOut" className="accordion-collapse collapse" data-bs-parent="#upcomingEventsAccordion">
          <div className="accordion-body">
        <a href="./img/flyers/flyer-2026-NNO.png" target="_blank" alt="2026 National Night Out August 4th">
          <img className="accordion-image-responsive" src="./img/flyers/flyer-2026-NNO.png" alt="thumbnail of 2026 National Night Out August 4th flyer" />
        </a>
          </div>
        </div>
      </div>
    )
}